<div *ngIf="text" [ngClass]="position" class="ks-tooltip">
  <div
    [innerHTML]="text | safe : 'html'"
    [ngStyle]="{ 'max-width': maxWidth, 'text-align': textAlign }"
    class="ks-tooltip-content"
  ></div>
  <div class="ks-tooltip-arrow"></div>
</div>
